import { Injectable } from '@angular/core';

import * as Objects from '../../objects';

/**
 * Service for get current user and organization logged in the app
 */

// https://www.damirscorner.com/blog/posts/20211015-InterfacesInAngularDependencyInjection.html
export abstract class CurrentSessionService {
    abstract getUser() : Objects.User | null;
    abstract getOrganization() : Objects.Organization | null;
}

@Injectable({
    providedIn: "root",
})
export class DefaultCurrentSessionService implements CurrentSessionService {
    getUser = () => null;
    getOrganization = () => null;
}